import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const NotificationNoEditModal = ({
    isOpen,
    title,
    toggle,
    isInSendingWindow,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            className="modal-dialog-v-centered modal-horizontally-centered"
        >
            <ModalHeader>Edit Notification</ModalHeader>
            <ModalBody>
                The <strong>{title}</strong> notification{" "}
                {isInSendingWindow ? "is currently being" : "has been"} sent, so
                it can no longer be edited.
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-cancel col" onClick={toggle}>
                    Cancel
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default NotificationNoEditModal
